import { Component, OnInit, Input } from '@angular/core';

import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap';
import { DataService } from '../../services/data.service';

@Component({
	selector: 'app-contract-terms-free-trial-upgrade-modal',
	templateUrl: './contract-terms-free-trial-upgrade-modal.component.html',
})
export class ContractTermsFreeTrialUpgradeModalComponent implements OnInit {

	@Input() cpBillingPlan: 'lite' | 'economy' | 'business' | 'first';
	@Input() schoolName: string;

	today = new Date();
	constructor(
		private bsModalRef: BsModalRef,
		public dataSvc: DataService
	) { }

	ngOnInit() {
	}

	getFirstBillingInvoiceDate(): Date {
		let todayMom = moment();

		return todayMom.clone().add(1,'M').startOf('M').toDate();
	}

	getFeatureBulletText(): string {
		let text = ``;

		if (this.cpBillingPlan === 'lite') {
			text += "for a limited ChildPilot feature set.";
		}
		else {
			text += "for all of ChildPilot's core features including ChildPilot Data Management, Billing, Attendance, Scheduling, Communication, Reporting, & Staff/Parent Mobile App's. Your ChildPilot experience also includes ";
		}

		if (this.cpBillingPlan !== 'lite') {
			text += `<b>
			${this.dataSvc.getBillingPlanTexts(this.cpBillingPlan)} texts/month + ${this.dataSvc.getBillingPlanDocuments(this.cpBillingPlan)} free digitalized document pages
			</b>`;

			text += ` and ${this.dataSvc.getBillingPlanChildrenAmt(this.cpBillingPlan)} children.`
		}

		text += ``


		return text;
	}

	dismissModal() {
        this.bsModalRef.hide();
	}
	

    printElement() {
        let elem = document.getElementById('print-this')
        var domClone = elem.cloneNode(true);

        var $printSection = document.createElement("div");
        $printSection.id = "printSection";
        document.body.appendChild($printSection);
    
        $printSection.appendChild(domClone);
        window.print();
    }
}
